import { LEVEL } from "../../consts";
import type { Level } from "../../types";

export type LoRouteParams = {
  idString: string | undefined
  learningObjectTypology: Level | undefined
  idNumber: number
  courseIdNumber: number
  rootIdNumber: number
}

export function resolveLoRouteContext(route: LoRouteParams): LoRouteParams {
  const {
    idString: routeIdString,
    learningObjectTypology: routeLearningObjectTypology,
    idNumber: routeIdNumber,
    courseIdNumber: routeCourseIdNumber,
    rootIdNumber: routeRootIdNumber
  } = route;

  const hasParentContext =
    (!isNaN(routeRootIdNumber) && routeRootIdNumber !== routeIdNumber)
    || (!isNaN(routeCourseIdNumber) && routeCourseIdNumber !== routeIdNumber);

  if (!hasParentContext) {
    return {
      courseIdNumber: routeCourseIdNumber,
      idNumber: routeIdNumber,
      idString: routeIdString,
      learningObjectTypology: routeLearningObjectTypology,
      rootIdNumber: routeRootIdNumber
    };
  }

  const isPath = !isNaN(routeRootIdNumber) && routeRootIdNumber !== routeIdNumber;
  const idNumber = isPath ? routeRootIdNumber : routeCourseIdNumber;

  return {
    courseIdNumber: isPath ? NaN : idNumber,
    idNumber,
    idString: String(idNumber),
    learningObjectTypology: isPath ? LEVEL.PATH : LEVEL.COURSE,
    rootIdNumber: isPath ? idNumber : NaN
  };
}
